import './call.css';
import {FaPhoneAlt} from 'react-icons/fa';

function Call(){
    return(
        <>
        <a href="tel:+6289001010" className="call-btn">
    <FaPhoneAlt className="call-icon"/>
    </a>
        
        </>
    )


}

export default Call;
